import React, { useState } from 'react';
import { colors } from '@/lib/colors';
import { DemiLightText } from '@/lib/Text';
import SvgIcon from '@/components/SvgIcon';

interface ActionButtonProps {
    iconName: any;
    label: string;
    onClick: () => void;
    strokeWidth?: number;
    isFill?: boolean;
    className?: string; // Allow custom styling if needed
    size?: number;
    fontSize?: number;
}

const ActionButton = ({
    iconName,
    label,
    onClick,
    strokeWidth = 1,
    isFill = false,
    className,
    size = 16,
    fontSize = 16,
}: ActionButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            className={`flex items-center gap-[8px] px-[17px] py-[7px] border rounded-[9px] transition-colors ${
                isHovered ? 'bg-[#ECF1FC] border-[#ECF1FC]' : 'bg-[#F2F4F6] border-[#E0E0E0]'
            } ${className}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <SvgIcon
                name={iconName}
                size={size}
                stroke={isFill ? colors.trans : isHovered ? colors.primary : colors.Text_1}
                fill={isFill ? (isHovered ? colors.primary : colors.Text_1) : colors.trans}
                strokeWidth={strokeWidth}
            />
            <DemiLightText
                fontSize={fontSize}
                lineHeight={22}
                color={isHovered ? colors.primary : colors.Text_1}
                letterSpacing={-0.5}
            >
                {label}
            </DemiLightText>
        </button>
    );
};

export default ActionButton;
